
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import AttachmentsArea from "@/components/forms/AttachmentsArea.vue";
import Discussion from '@/components/courses/Discussion.vue';
import BoxScore from '@/components/teams/BoxScore.vue';
import { CalendarEventModel } from '@/models/calendar/CalendarEventModel';
import LineupCard from '@/components/teams/LineupCard.vue';
import { TeamModel } from '@/models/team';
import { LineupModel } from '@/models/lineup';
import PlayerManagement from "@/components/teams/PlayerManagement.vue";
import { CalendarEventParticipant, GameOccurence } from '@/../types/interfaces';
import TeamAttendance from '@/components/teams/TeamAttendance.vue';
import EventRsvpControl from '@/components/teams/events/EventRsvpControl.vue';
import EventAvailabilitySummary from '@/components/teams/events/EventAvailabilitySummary.vue';
import { occurrenceKeyForViewedDate } from '@/helpers/availability';
import EventAssignments from '@/components/teams/events/EventAssignments.vue';
import * as Routes from "@/../types/constants/web_client_user.routes";
import { EventProgress, SoccerTimelinePeriodValues, SoccerGameOccurenceTypeValues, SoccerGameTimingValues, SoccerGameTiming } from '@/../types/enums';
import { CalendarEventsApi } from "@/api/CalendarApi";
import SoccerGameTimeline from "@/components/teams/SoccerGameTimeline.vue";
import { TeamEventType } from '@/../types/enums';
import ContextMenu from '@/components/ui/ContextMenu.vue';
import { formatDatePretty,getTime,eventProgress, formatDateHyphensYYYYMMDD } from '@/helpers/date';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import viewMapPic from "@/assets/img/view-map-icon.png";
import { AuthMixin, CurrentTeamMixin, VuetifyMixin, BAIconsMixin, AppHostnameMixin, StringsMixin } from '@/mixins';
import { Tag } from '@/models/tag/Tag';
import { getEventColor } from '@/helpers/default-event-types';
import { VideoClipModel } from '@/models/video/VideoClipModel';
import PlayerTagger from "@/components/teams/PlayerTagger.vue";
import BAVideoStudio from '@/components/videoStudio/BAVideoStudio.vue';
import VideoClipLibrary from '@/components/ui/videos/VideoClipLibrary.vue';
import VideoLibraryProvider from '@/components/hoc/VideoLibraryProvider.vue';
import { GameResultApi } from '@/api/GameResultApi';
import { GameResultModel } from '@/models/calendar/GameResultModel';

@Component({
	components: { BoxScore, Discussion,LineupCard,PlayerManagement,TeamAttendance,SoccerGameTimeline, AttachmentsArea, ContextMenu, PlayerTagger, BAVideoStudio, VideoClipLibrary, VideoLibraryProvider, EventRsvpControl, EventAvailabilitySummary, EventAssignments, },
})

export default class TeamEvent extends Mixins(AuthMixin, CurrentTeamMixin, VuetifyMixin, BAIconsMixin, AppHostnameMixin, StringsMixin) {
	get teamEventId(): string | null{
		if(!this.event) return null;
		return this.event.id;
	}
	eventTab: string = 'details';
	get MyProfileId(): string | null{
		return this.AthleteAppActive ? this.AthleteId : this.CoachId;
	}
	get MyParticipantId(): string | null{
		if(!this.event) return null;
		const id = this.MyProfileId;
		const p = (this.event.participants || []).find(x => x.athleteId === id || x.coachId === id);
		return p ? p.id : null;
	}
	onEventUpdated(updated: CalendarEventModel): void{
		if(!this.event || !updated) return;
		this.event.participants = updated.participants;
		this.event.assignments = updated.assignments;
		this.event.arrivalTime = updated.arrivalTime;
		this.event.attendanceFinished = updated.attendanceFinished;
	}
	get teamId(): string{
		if(!this.team) return "";
		return this.team.id;
	}
	@Prop({ default: false }) athleteMode: boolean;
	@Prop({ default: null }) event: CalendarEventModel | null = null;
	@Prop({ default: null }) gameResult: GameResultModel | null = null;
	@Prop({ default: null }) focusDate: string;

	get GameResult(): GameResultModel{
		if(this.gameResult === null) return new GameResultModel();
		return this.gameResult;
	}

	get FocusDate(): Date {
		return new Date(this.focusDate ? this.focusDate : undefined);
	}

	@Prop({ default: null }) team: TeamModel | null = null;
	@Prop({ default: null }) calendarId: string | null = null;
	@Prop({ default: null }) calendarEventsApi: CalendarEventsApi | null = null;
	@Prop({ default: null }) gameResultApi: GameResultApi | null = null;
	deleteEventLoading: boolean = false;
	showDeleteDialog: boolean = false;
	showFinishDialog: boolean = false;
	showFinishLoading: boolean = false;
	videoStudioVisible: boolean = false;

	@Watch('GameResult')
	setupFormValue(gameResult: GameResultModel): void{
		if(gameResult === null) return;
		this.formValue.homeScore = gameResult.homeScore;
		this.formValue.opponentScore = gameResult.opponentScore;
		this.formValue.gameTiming = gameResult.gameTiming;
		this.formValue.showTimeline = gameResult.showTimeline;
	}

	formValue: {
		homeScore: number,
		opponentScore: number,
		gameTiming: SoccerGameTiming,
		showTimeline: boolean,
	} = {
		homeScore: null,
		opponentScore: null,
		gameTiming: null,
		showTimeline: false,
	};
	viewMapPic = viewMapPic;
	SoccerGameOccurenceTypeValues = SoccerGameOccurenceTypeValues;
	SoccerTimelinePeriodValues = SoccerTimelinePeriodValues;
	SoccerGameTimingValues = SoccerGameTimingValues;

	get VideoParentId(): string{
		return this.teamId;
	}

	get EventReady(): boolean{
		return this.event !== null;
	}

	get ShowEventVideoClips(): boolean{
		return this.teamEventId !== undefined;
	}

	get EventVideoTagFilter(): Tag[]{
		return [
			new Tag(this.event.EventName, this.event.RootId, this.getColor(getEventColor(this.event.eventType))),
		];
	}

	filterPlayers: Tag[] = [];
	playerClipFilter(clip: VideoClipModel): boolean{
		return clip.hasTag(this.filterPlayers);
	}

	/**
	 * Attendance taking is open for editing. Held on the event itself (not the game result)
	 * so training sessions, which never have a game result, can take attendance too.
	 */
	get AttendanceOpen(): boolean{
		if (this.event === null) return false;
		return this.event.attendanceFinished === false;
	}

	/**
	 * Only team staff may edit attendance: admin, head coach or assistant coach on the team,
	 * or a coach who was added to this event as staff. The backend enforces the same rule
	 * through the team Write ACL.
	 */
	get CanEditAttendance(): boolean{
		if (this.AthleteAppActive) return false;
		if (!this.team || !this.event) return false;
		const coachId = this.CoachId;
		if (!coachId) return false;
		if (this.team.IsTeamStaff(coachId)) return true;
		return this.StaffParticipants.some(p => p.coachId === coachId);
	}

	get Lineup(): LineupModel{
		if (this.gameResult === null){
			return null
		}
		return this.GameResult.lineup
	}

	get EventProgress(): EventProgress{
		if (this.event === null){
			return null
		}
		return eventProgress(this.event.start, this.event.end, this.FocusDate)
	}

	get MapLink(): string{
		if (this.event.address){
			const address = this.event.address
			return encodeURI('https://www.google.com/maps/search/?api=1&query='+address)
		} else if (this.event.venue){
			const venue = this.event.venue
			return encodeURI('https://www.google.com/maps/search/?api=1&query='+venue)
		}
		return 'https://www.google.com/maps'
	}

	get FileUploadApiPrefix(): string {
		return `team/${this.teamId}/calendar/${this.calendarId}/calendarEvent/${this.DocumentUploadId}/files`;
	}

	get EventRootId(): string | null{
		if(this.event){
			return this.event.RootId;
		}
		return null;
	}

	get DocumentUploadId(): string | null{
		const dateSlug = formatDateHyphensYYYYMMDD(this.FocusDate)
		return `${this.EventRootId}_${dateSlug}`;
	}

	get DiscussionId(): string{
		const dateSlug = formatDateHyphensYYYYMMDD(this.FocusDate);
		return `${this.EventRootId}_event_${dateSlug}`;
	}

	defaultGameOccurance = (): GameOccurence => ({
		team: "",
		type: null,
		eventTime: null,
		player: "",
		subPlayerIn: "",
		subPlayerOut: "",
		period: null,
	});
	get Loading(): boolean {
		return !this.CurrentTeamReady;
	}

	get IsGame(): boolean{
		if (this.event === null){
			return false
		}
		return this.event.eventType === TeamEventType.Game;
	}

	get IsPractice(): boolean{
		if (this.event === null){
			return false
		}
		return this.event.eventType === TeamEventType.Practice
	}

	get IsSocial(): boolean{
		if (this.event === null){
			return false
		}
		return this.event.eventType === TeamEventType.Social
	}

	get EventName(): string {
		if (this.event === null){
			return ''
		}
		return this.event.name;
	}

	get EventInfoDate(): string | null {
		if (this.event === null){
			return null
		}
		const date = this.event.recurrenceRule === null ? this.event.start : this.FocusDate;

		return formatDatePretty(date);
	}

	get EventInfoTime(): string | null {
		if (this.event === null){
			return null
		}
		return getTime(this.event.start);
	}
	/**
	 * The date this page is showing. A repeating event keeps one answer per date, so every
	 * availability read and write here has to carry it, or this page and the team availability
	 * grid disagree about which date they are editing.
	 */
	get OccurrenceDate(): string | undefined{
		if(this.event === null) return undefined;
		return occurrenceKeyForViewedDate(this.event, this.FocusDate);
	}
	get AllParticipants(): CalendarEventParticipant[]{
		if(this.event === null) return [];
		return this.event.participants;
	}
	get PlayerParticipants(): CalendarEventParticipant[]{
		return this.AllParticipants.filter(p => !p.coachId);
	}
	get StaffParticipants(): CalendarEventParticipant[]{
		return this.AllParticipants.filter(p => !!p.coachId);
	}
	/** Coaches and players alike respond for themselves, as long as they're on the event */
	get IAmParticipant(): boolean{
		return this.MyProfileId !== null && this.MyParticipantId !== null;
	}


	get FormHasLineup(): boolean {
		if (this.event === null){
			return false
		}
		return this.GameResult.lineup !== null;
	}

	get FormColumns(): {
		left: Record<string, string>;
		right: Record<string, string>;
		} {
		return {
			left: {
				cols: "12",
				md: "6",
				sm: "12",
			},
			right: {
				cols: "12",
				md: "6",
				sm: '12'
			}
		};
	}

	goBack(): void {
		if (this.$route.query.largeCalendar !== undefined) {
			this.$router.push({
				name: Routes.FullScreenCalendar,
				params:{
					teamId: this.teamId
				}
			});
		}else if (this.AthleteAppActive) {
			this.$router.push({
				name: Routes.AthleteTeamDashboard
			});
		} else {
			this.$router.push({
				name: Routes.TeamDashboardCalendar,
			});
		}
	}

	/**
	 * TeamAttendance has already persisted the change through the attendance endpoint;
	 * this only mirrors it onto the local event so the buttons flip straight away.
	 */
	setAttendanceOpen(open: boolean): void{
		if (this.event === null) return;
		this.event.attendanceFinished = !open;
		this.$emit('update:attendance-finished');
	}

	deleteOccurence(index: number): void{
		this.GameResult.gameOccurence.splice(index,1);
		this.updateGameResult();
	}

	addOccurence(): void{
		this.GameResult.gameOccurence.push(this.defaultGameOccurance())
		this.updateGameResult();
	}

	errorMessage: string | null = null;

	async confirmFinish(): Promise<void> {
		this.formValue.showTimeline = true;
		await this.updateGameResult();
		this.showFinishDialog = false;
	}

	async updateGameResult(): Promise<void> {
		if( !this.gameResult ) this.gameResult = new GameResultModel();
		this.gameResult.homeScore = this.formValue.homeScore;
		this.gameResult.opponentScore = this.formValue.opponentScore;
		this.gameResult.gameTiming = this.formValue.gameTiming;
		this.gameResult.showTimeline = this.formValue.showTimeline;
		await this.$emit('update:game-result', this.gameResult);
	}

	async patchEvent(event: CalendarEventModel): Promise<CalendarEventModel>{
		this.updateGameResult();
		return await this.calendarEventsApi.patch(event);
	}

	async submit(validate: () => Promise<boolean>): Promise<void>{
		this.errorMessage = null;
		const isValid = await validate();
		if(!isValid){
			this.errorMessage = 'Please ensure all required fields are provided.';
			this.$vuetify.goTo(0);
		}else{
			this.showFinishDialog = true;
		}
	}


	async deleteEvent(): Promise<CalendarEventModel | null> {
		try {
			const teamEvent = new CalendarEventModel();
			teamEvent.id = this.teamEventId;
			this.deleteEventLoading = true;
			await this.calendarEventsApi.deleteByRootId(teamEvent.rootId);
			this.deleteEventLoading = false;
			this.goBack();
			return teamEvent;
		} catch (e) {
			this.deleteEventLoading = false;
			console.log("Failed to delete event", e);
			return null;
		}
	}

	editEvent():void{
		this.$router.push({
			name: Routes.TeamEventEdit,
			params:{
				teamEventId: this.teamEventId,
				teamId: this.teamId,
			},
			query: {
				focusDate: this.FocusDate.toISOString(),
			}
		});
	}
}
